import { files } from "@/firebase.js";
import api from "@/api.js";
import events from "./events";

export default {
  namespaced: true,
  modules: {
    events
  },
  state: {
    list: [],
    listLoading: false,
    hubChainList: [],
    hubChainListLoading: false,
    hubChainDeviceList: [],
    hubChainDeviceListLoading: false,
    deviceStatuses: [],
    deviceStatusesLoading: false
  },
  mutations: {
    setList(state, devices) {
      state.list = devices;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    },
    setHubChainList(state, payload) {
      state.hubChainList = payload;
    },
    setHubChainListLoading(state, payload) {
      state.hubChainListLoading = payload;
    },
    setHubChainDeviceList(state, payload) {
      state.hubChainDeviceList = payload;
    },
    setHubChainDeviceListLoading(state, payload) {
      state.hubChainDeviceListLoading = payload;
    },
    setDeviceStatuses(state, payload) {
      state.deviceStatuses = payload;
    },
    setDeviceStatusesLoading(state, payload) {
      state.deviceStatusesLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let devices = await api.get("devices");
      commit("setList", devices.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("applications/loadAll", null, { root: true });

      return returnData;
    },
    async createMultiple({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/csv", payload.data)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("applications/loadAll", null, { root: true });

      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("devices", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async keyRegen({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/keyRegen", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async keyRegenRockblock({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/keyRegenRockblock", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },

    // HUB CHAINS
    async loadHubChains({ commit }, id) {
      commit("setHubChainListLoading", true);
      let hubChains = await api.get("devices/hubChains", {
        params: {
          id: id
        }
      });
      commit("setHubChainList", hubChains.data);
      commit("setHubChainListLoading", false);
    },
    async loadHubChainDevices({ commit }, id) {
      commit("setHubChainDeviceListLoading", true);
      let hubChains = await api.get("devices/hubChains/devices", {
        params: {
          id: id
        }
      });
      commit("setHubChainDeviceList", hubChains.data);
      commit("setHubChainDeviceListLoading", false);
    },
    async newHubChain({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/hubChain", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });

      dispatch("loadHubChains", payload.devices_id);

      return returnData;
    },
    async saveHubChain({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("devices/hubChain", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadHubChains", payload.devices_id);
      return returnData;
    },
    async addDeviceToChain({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/hubChain/addDevice", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadHubChainDevices", payload.hubChains_id);
      return returnData;
    },
    async saveChainDevice({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/hubChain/saveDevice", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadHubChainDevices", payload.hubChains_id);
      return returnData;
    },
    async removeDeviceFromChain({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("devices/hubChain/removeDevice", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadHubChainDevices", payload.hubChains_id);
      return returnData;
    },

    // Device Statuses
    async loadAllDeviceStatuses({ commit }) {
      commit("setDeviceStatusesLoading", true);
      let deviceStatuses = await api.get("devices/statuses");
      commit("setDeviceStatuses", deviceStatuses.data);
      commit("setDeviceStatusesLoading", false);
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    },
    hubChainList(state) {
      return state.hubChainList;
    },
    hubChainListLoading(state) {
      return state.hubChainListLoading;
    },
    hubChainDeviceList(state) {
      return state.hubChainDeviceList;
    },
    hubChainDeviceListLoading(state) {
      return state.hubChainDeviceListLoading;
    },
    deviceStatuses(state) {
      return state.deviceStatuses;
    },
    deviceStatusesLoading(state) {
      return state.deviceStatusesLoading;
    }
  }
};
